import { Button } from "reactstrap";
import styles from './AdvertiseBox.module.scss';
import { useNavigate, useParams } from "react-router-dom";

export default function AdvertiseBox() {
    const navigate = useNavigate();
    const { id } = useParams();
    

  return (
    <div className={`bg-white p-4 mb-3 lgtBackground d-flex flex-row`} >
        <div className={`mb-2 fw-bold ${styles.advertiesIcon} me-3`}>
            <i className={`bi bi-graph-up-arrow text-primary`}></i>
        </div>
        <div className={`${styles.advertiseContent}`}>
            <div className="fw-bold mb-2">
                Promote your product
            </div>
            <Button 
                className={`general-button`}
                onClick={() => navigate(`/dashboard/advertise/?pId=${id}`)}
            >
                <i className='bi bi-megaphone me-2'></i>
                <span>
                    Promote
                </span>
            </Button>
        </div>
    </div>
  )
}
